import React, { useCallback, useContext } from "react";

import { ModalContext } from "../../contexts/ModalContext";
import { OrderItem } from "../../generated/graphql";
import { LocalisedText } from "../../i18n";
import { displayPrice } from "../../utils/price";

import ProductDetailModal from "../ProductDetailModal";

import styles from "./OrderProductItem.module.scss";

interface OrderProductItemProps {
  item: OrderItem;
}

const OrderProductItem: React.FC<OrderProductItemProps> = (
  props: OrderProductItemProps
) => {
  const { presentModal } = useContext(ModalContext);
  const { item } = props;

  const onClickItem = useCallback(() => {
    presentModal(<ProductDetailModal item={item} />, true);
  }, [item, presentModal]);

  return (
    <div className={styles.productItem} onClick={onClickItem}>
      <div
        className={styles.productThumbnail}
        style={{
          backgroundImage:
            item.images.length > 0 ? `url("${item.images[0]}")` : undefined,
        }}
      />
      <div className={styles.productInfo}>
        <div className={styles.itemName}>{item.name}</div>
        <div>
          <div className={styles.quantity}>
            <LocalisedText id="view.orderProductItem.quantity" />{" "}
            {item.quantity}
          </div>
          <div className={styles.price}>
            {item.currency}$ {displayPrice(Number(item.unitPrice))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderProductItem;
